import httpClient from "@/plugins/axios";

export const getResources = async (page, pageSize = 10) => {
    const response = await httpClient.get(`/v1/resources/?page=${page}&page_size=${pageSize}`);
    return response;
}

export const download = async (id) => {
    const response = await httpClient.get(`/v1/resources/${id}/view/`,
        {
            responseType: 'blob',
        });
    return response;
}

export const getResource = async (id) => {
    const response = await httpClient.get(`/v1/resources/${id}/`);
    return response;
}
